<template>
  <el-container class="layout-container">
    <el-aside width="200px">
      <el-menu :default-active="$route.path" class="el-menu-vertical" background-color="#272a2e" text-color="#fff"
        router>
        <el-menu-item index="/categories">
          <el-icon>
            <Folder />
          </el-icon>
          <span>分类管理</span>
        </el-menu-item>
        <el-menu-item index="/products">
          <el-icon>
            <Box />
          </el-icon>
          <span>产品管理</span>
        </el-menu-item>
        <el-menu-item index="/applicationScenarios">
          <el-icon>
            <Collection />
          </el-icon>
          <span>应用分类管理</span>
        </el-menu-item>
        <el-menu-item index="/productApplication">
          <el-icon>
            <Files />
          </el-icon>
          <span>应用产品管理</span>
        </el-menu-item>
        <el-menu-item index="/banner">
          <el-icon>
            <Picture />
          </el-icon>
          <span>轮播图</span>
        </el-menu-item>
         <el-menu-item index="/workshop">
          <el-icon>
            <OfficeBuilding />
          </el-icon>
          <span>车间图</span>
        </el-menu-item>
        <el-menu-item index="/certification">
          <el-icon>
            <Medal />
          </el-icon>
          <span>证书</span>
        </el-menu-item>
        <el-menu-item index="/user">
          <el-icon>
            <User />
          </el-icon>
          <span>管理员</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header>
        <div class="header-title">正科电机后台管理系统</div>
        <el-dropdown>
          <span class="user-info">
            <el-avatar icon="user" size="small" />
            <span>管理员</span>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-header>

      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { Folder, Box, User ,Files ,Collection,Picture,OfficeBuilding,Medal} from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const router = useRouter()
const authStore = useAuthStore()

const handleLogout = () => {
  authStore.logout()
  router.push('/login')
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #409eff;
  color: white;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: white;
}

.user-info span {
  margin-left: 8px;
}

.el-aside {
  background-color: #304156;
}

.el-menu-vertical {
  border-right: none;
  height: 100%;
}


.el-main {
  padding: 20px;
}
</style>